import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e38afb40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choose_content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "江苏省安全生产协会二级标准化创建能力考试", -1))

import axios from 'axios'
  import { onMounted, ref } from 'vue'
  import { useRouter } from 'vue-router'
  import store from "@/store";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'choose',
  setup(__props) {

  const router = useRouter();

  const hanlderExam = (row:any) => {
    store.commit('setExam', row)
    router.push({
      name: 'Examre',
      params: {
        enrollId: row.enrollId,
        planId: row.trainPlanId,
        planstudentId: row.id
      }
    })
  }

  const hanlderExamination = (row:any) => {
    store.commit('setExam', row)
    router.push({
      name: 'Examination',
      params: {
        enrollId: row.enrollId,
        planId: row.trainPlanId,
      }
    })
  }

  const tableData:any = ref([])

  onMounted(() => {
    getAnswerList()
  })

  const fromartStatus = (status:number) => {
    return { 1:'待考', 2:'未通过', 3:'通过', 4:'未通过', 5:'缺考' }[status] || status
  }

  const getAnswerList = async () => {
    let { data } = await axios.get(`/api/exam/plan_student/getStudentRecordList`);
    if ( data.code === 200 ) {
      tableData.value = data.data
    }
  }
  


return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_table, {
      data: tableData.value,
      size: "large",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { label: "科目" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.subjectName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "学员姓名" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.studenName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "准考证" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.admissionTicket), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "证件号",
          width: "180"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.idcardNo), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "联系电话" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(scope.row.phoneNumber), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "状态" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(fromartStatus(scope.row.examState)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            (scope.row.examState === 1)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  size: "large",
                  onClick: ($event: any) => (hanlderExam(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("开始考试")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})